import React, { useState } from 'react';
import { Image } from 'expo-image';
import BotHeroFrame from './BotHeroFrame';

export default function BotHero({ agent, compact = false }) {
  const [failedSource, setFailedSource] = useState(null);
  const size = compact ? 72 : 96, source = agent.avatarPath;
  return <BotHeroFrame name={agent.name} compact={compact} image={source && source !== failedSource &&
    <Image source={{ uri: source }} contentFit="cover" accessible={false} style={{ width: size, height: size }} onError={() => setFailedSource(source)} />} />;
}
